const authenticateQuery = ({ firebaseUser, idToken }) => `
mutation {
  authenticate(
    name: "${firebaseUser.displayName}"
    email: "${firebaseUser.email}"
    idToken: "${idToken}"
  ) {
    id
    name
    email
    facilities {
      id
    }
  }
}
`;

export default class NightingaleService {
  constructor(config = {}) {
    this._url = config.url;
  }

  _call = async (query, idToken) => {
    const resp = await fetch(process.env.REACT_APP_NIGHTINGALE_ENDPOINT, {
      method: 'post',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${idToken}`,
        'x-api-key': process.env.REACT_APP_NIGHTINGALE_API_KEY,
      },
      body: JSON.stringify({
        query,
      }),
    });

    const json = await resp.json();
    if (json.errors) {
      throw new Error(json.errors[0].message);
    }
    return json;
  };

  authenticate = async (firebaseUser, idToken) => {
    const query = authenticateQuery({ firebaseUser, idToken });
    const json = await this._call(query, idToken);
    return json.data.authenticate;
  };
}



// WEBPACK FOOTER //
// ./src/services/NightingaleService.js